module.exports = __webpack_public_path__ + "febcc1b18059405d2a1b169a335888f5.svg";